import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DataCatalogueComponent } from "../../data-catalogue.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";
@Component({
  selector: "app-add-profile-dialog",
  templateUrl: "./add-profile-dialog.component.html",
})
export class AddProfileDialogComponent implements OnInit {
  profiles: any[] = [];
  selectedProfiles: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddProfileDialogComponent>,
    private catalogueService: DataCatalogueService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {
    const existingProfileRefs = this.data?.existingProfileRefs ?? [];

    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (res) => {
          console.log("Loaded profiles:", res);

          this.profiles = res.filter(
            (profile: any) => !existingProfileRefs.includes(profile.uuid),
          );
        },
        error: (err) => console.error("Error loading profiles:", err),
      });
  }

  addSelectedProfiles(): void {
    this.dialogRef.close(
      this.selectedProfiles.map((p) => ({
        name: p.name,
        ref: p.uuid,
      })),
    );
  }
}
